// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.green-completed {
    color: #9abf48;
}

.index-small-btn {
    padding: 0rem .5rem;
}

html * {
    font-family:
    Arial,
    sans-serif;
}

.pointer-on-hover {
    cursor: pointer;
}

.color-changer-style {
    min-height: 100%;
    min-width: 100%;
    color: white;
    border: 0;
}

.color-picker-disabler {
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
}

.instructionTitle {
    padding: 15px 20px;
    border-bottom: 1px solid rgba(208, 219, 220, 0.68);
    color: #9c989d;
}

.instructionBody {
    padding: 15px 20px;
    height: 70%;
    overflow: auto;
    bottom: 0;
}


/* Spinny thingy at Active Installation List View */
.spinny-thingy-container {
    height: 70vh;
}

.water-alarm {
    height: 10px;
    background: repeating-linear-gradient(45deg, black, black 35px, #e2f04e 35px, #e2f04e 70px);
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
}


a:link {
    text-decoration: none;
}

.btn-account {
    color: #9D9D99;
}

.btn-account:hover {
    color: white;
}

.spinny-thingy-margin {
    margin-top: 20vh;
}

.success-box-color {
    background-color: #C9EBD1;
}

.error-box-color {
    background-color: #E3C2C5;
}

.active-device {
    background-color: #337ab7 !important;
}

.light-grey-text {
    color: #9D9D9D;
}

.triangle-const-width {
    display: flex;
    justify-content: center;
    width: 1rem;
}

.selector-z-index {
    position: relative;
    z-index: 50;
}

.selector-z-index-tier-2 {
    position: relative;
    z-index: 40;
}

/* This is to keep the footer down */
html,
body {
    width: 100%;
    height: 100vh;
    font-size: 14px;
}

#root {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

#content,
main {
    display: flex !important;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 1;
}
#content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/v2_remake.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;;cAEU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,UAAU;IACV,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,SAAS;AACb;;;AAGA,mDAAmD;AACnD;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,2FAA2F;IAC3F,2BAA2B;IAC3B,4BAA4B;AAChC;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA,oCAAoC;AACpC;;IAEI,WAAW;IACX,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;;IAEI,wBAAwB;IACxB,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;AAChB","sourcesContent":[".green-completed {\n    color: #9abf48;\n}\n\n.index-small-btn {\n    padding: 0rem .5rem;\n}\n\nhtml * {\n    font-family:\n    Arial,\n    sans-serif;\n}\n\n.pointer-on-hover {\n    cursor: pointer;\n}\n\n.color-changer-style {\n    min-height: 100%;\n    min-width: 100%;\n    color: white;\n    border: 0;\n}\n\n.color-picker-disabler {\n    position: fixed;\n    top: 0px;\n    right: 0px;\n    bottom: 0px;\n    left: 0px;\n}\n\n.instructionTitle {\n    padding: 15px 20px;\n    border-bottom: 1px solid rgba(208, 219, 220, 0.68);\n    color: #9c989d;\n}\n\n.instructionBody {\n    padding: 15px 20px;\n    height: 70%;\n    overflow: auto;\n    bottom: 0;\n}\n\n\n/* Spinny thingy at Active Installation List View */\n.spinny-thingy-container {\n    height: 70vh;\n}\n\n.water-alarm {\n    height: 10px;\n    background: repeating-linear-gradient(45deg, black, black 35px, #e2f04e 35px, #e2f04e 70px);\n    border-left: 1px solid #ddd;\n    border-right: 1px solid #ddd;\n}\n\n\na:link {\n    text-decoration: none;\n}\n\n.btn-account {\n    color: #9D9D99;\n}\n\n.btn-account:hover {\n    color: white;\n}\n\n.spinny-thingy-margin {\n    margin-top: 20vh;\n}\n\n.success-box-color {\n    background-color: #C9EBD1;\n}\n\n.error-box-color {\n    background-color: #E3C2C5;\n}\n\n.active-device {\n    background-color: #337ab7 !important;\n}\n\n.light-grey-text {\n    color: #9D9D9D;\n}\n\n.triangle-const-width {\n    display: flex;\n    justify-content: center;\n    width: 1rem;\n}\n\n.selector-z-index {\n    position: relative;\n    z-index: 50;\n}\n\n.selector-z-index-tier-2 {\n    position: relative;\n    z-index: 40;\n}\n\n/* This is to keep the footer down */\nhtml,\nbody {\n    width: 100%;\n    height: 100vh;\n    font-size: 14px;\n}\n\n#root {\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n}\n\n#content,\nmain {\n    display: flex !important;\n    flex-direction: column;\n    align-items: stretch;\n    flex-grow: 1;\n}\n#content {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
